import React from "react";
import usflag from "../../assets/images/usflag.png";

const NotificationCarouselFaceShape = () => {
  return (
    <div className="py-2 w-full overflow-hidden">
      <div className="flex items-center justify-center">
        <div className="flex items-center transition-all duration-500 ease-in-out opacity-100 transform translate-y-0">
          <div className="text-xs text-[#6B7280] flex items-center font-['Inter',system-ui,-apple-system,sans-serif] whitespace-nowrap">
            <span className="font-semibold text-[#7C3A8D]">Anna</span>
            <span className="mx-1 text-[#6B7280]">Just Started her Back Relief Plan!</span>
            <img
              src={usflag}
              alt="US Flag"
              className="w-4 h-3 mx-1 rounded-sm object-cover shadow-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCarouselFaceShape;
